import LazyLoadImage from './lazyLoadImage'
import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'
import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'
import {qs} from '../shared/utils'

export const getImageQuery = ({
  activity,
  bgColor,
  design,
  outputFormat,
  parameters = [],
  personalization,
  productColor,
  productId,
  scale = 58,
  storeId,
  side,
  type = 1,
  ver = 1
}) =>
  qs(
    omitBy(
      {
        bgColor: bgColor && bgColor.match(/[\d|a-f]+/i)[0],
        d: design,
        dp: parameters.length ? parameters.map((p) => p || '').join('|') : null,
        outputformat: outputFormat,
        p: productId,
        pc: productColor,
        scale,
        schoolid: storeId,
        side,
        type,
        up_pp: personalization,
        up_ss: activity,
        ver
      },
      isNil
    )
  )

export default class ProductImage extends PureComponent {
  render() {
    const {
      activity,
      bgColor,
      design,
      imageHost,
      isLoading,
      outputFormat,
      parameters,
      personalization,
      productColor,
      productId,
      responsive,
      scale,
      storeId,
      style: styleProps,
      side,
      type,
      ver,
      lazy,
      ...rest
    } = this.props

    const productImageParams = getImageQuery({
      bgColor,
      design,
      parameters,
      outputFormat,
      productId,
      productColor,
      scale,
      storeId,
      side,
      type,
      personalization,
      activity,
      ver
    })

    return (
      <LazyLoadImage
        event={{action: 'impression', product: productId, design}}
        force={!lazy}
        onError={this.props.onError}
        onLoad={this.props.onLoad}
        responsive={responsive}
        src={
          isLoading
            ? undefined
            : `${imageHost}/GetImage.iaspx?${productImageParams}`
        }
        style={styleProps}
        {...rest}
      />
    )
  }
}

ProductImage.propTypes = {
  activity: PropTypes.string,
  bgColor: PropTypes.string,
  design: PropTypes.number,
  imageHost: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  outputFormat: PropTypes.string,
  parameters: PropTypes.array,
  personalization: PropTypes.string,
  productColor: PropTypes.string,
  productId: PropTypes.number.isRequired,
  responsive: PropTypes.bool,
  scale: PropTypes.number,
  storeId: PropTypes.number,
  side: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.number,
  ver: PropTypes.number,
  lazy: PropTypes.bool
}

ProductImage.defaultProps = {
  lazy: true
}
